import * as React from 'react';
import Cards from '@cloudscape-design/components/cards';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Button from '@cloudscape-design/components/button';
import { DocumentContext } from '../../context/documentContext';
import { useContext, useEffect, useState } from 'react';
import Link from '@cloudscape-design/components/link';
import { kbSentenceItem } from '../../models/interfaces';
import { Spinner } from '@cloudscape-design/components';
import { OptionDefinition } from '@cloudscape-design/components/internal/components/option/interfaces';

interface Props {
  filterType: OptionDefinition[];
}
export const KnowledgeBaseModal = (props: Props) => {
  const { filterType } = props;
  // const { selectedItemsKbResults, addKBsentences } =
  //   useContext(DocumentContext);
  const {
    selectedItems,
    kbLoading,
    sentences,
    selectedItemsKbResults,
    localSelectedItems,
    setLocalSelectedItems
  } = useContext(DocumentContext);
  const [filteredResults, setFilteredResults] = useState<kbSentenceItem[]>([]);

  useEffect(() => {
    if (selectedItems.length > 0) {
      const alreadySelected = selectedItems[0].kbSentences;
      setLocalSelectedItems(alreadySelected);
    }
  }, [selectedItems, setLocalSelectedItems]);

  useEffect(() => {
    if (filterType.length === 0) {
      setFilteredResults(selectedItemsKbResults);
    } else {
      const filterValArray = filterType.map((ele) => ele.value);
      const temp = selectedItemsKbResults;
      const filteredResults = temp.filter((ele) =>
        filterValArray.includes(ele.knowledge_base_type)
      );
      setFilteredResults(filteredResults);
    }
  }, [filterType, selectedItemsKbResults, sentences]);

  return (
    <SpaceBetween direction="vertical" size="l">
      {!kbLoading ? (
        <>
          <Cards
            onSelectionChange={({ detail }) =>
              setLocalSelectedItems(detail?.selectedItems ?? [])
            }
            selectedItems={localSelectedItems}
            cardDefinition={{
              header: (item) => (
                <p style={{ fontStyle: 'italic', fontWeight: 'normal' }}>
                  {item.text}
                </p>
              ),
              sections: [
                {
                  id: 'Context',
                  header: 'Context',
                  content: (item) => item.Context
                },
                {
                  id: 'parameters',
                  header: 'Parameters',
                  content: (item) => item.All_Parameters.join(' ')
                },
                {
                  id: 'kbType',
                  header: 'Type',
                  content: (item) => item.knowledge_base_type
                },
                {
                  id: 'Similarity',
                  header: 'Similarity',
                  content: (item) =>
                    !isNaN(item.similarity * 100)
                      ? `${(item.similarity * 100).toFixed(2)} %`
                      : ''
                },
                {
                  id: 'link',
                  // header: 'Link',
                  content: (item) => (
                    <Link href="https://www.example.com" external>
                      {item.docName}
                    </Link>
                  )
                }
              ]
            }}
            cardsPerRow={[{ cards: 1 }]}
            items={filteredResults}
            // items={selectedItemsKbResults}
            loadingText="Loading resources"
            selectionType="multi"
            trackBy="_id"
            visibleSections={[
              'text',
              'link',
              'Context'
            ]}
            empty={
              <Box
                margin={{ vertical: 'xs' }}
                textAlign="center"
                color="inherit"
              >
                <SpaceBetween size="m">
                  <b>No resources found</b>
                </SpaceBetween>
              </Box>
            }
          />
          <SpaceBetween size={'s'} direction="horizontal">
            {/* <Button
              // disabled={!(localSelectedItems.length > 0)}
              loading={updateSentenceLoading}
              onClick={() => {
                addSentencesToReport();
              }}
            >
              Save Pinned
            </Button> */}
            {/* {!refreshKbLoading ? (
              <Button onClick={() => handleKBRefresh()}>Search KB</Button>
            ) : (
              <Button loading variant="primary">
                Searching Knowledge Base
              </Button>
            )} */}
          </SpaceBetween>
        </>
      ) : (
        <Spinner></Spinner>
      )}
    </SpaceBetween>
  );
};
